/**
 * Weighting reports from the last Transform Apply, so the weighting step can
 * show what its CALCWEIGHTS achieved. Session only: not persisted, since a
 * report belongs to the data and targets it was run with.
 */
import { create } from "zustand"
import { WeightingReport } from "types/engineOutput.types"

interface WeightingReportStore {
  reports: WeightingReport[]
  setReports: (reports: WeightingReport[]) => void
}

export const useWeightingReportStore = create<WeightingReportStore>()(
  (set) => ({
    reports: [],
    setReports: (reports) => set({ reports }),
  })
)
